import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';

// Tabs
import DetailsTab from "./Tabs/Details";
import Payments from "./Tabs/Payments";


  const tabContent = [
    {panel: "details", content: <DetailsTab />},
    {panel: "payments", content: <Payments />},
  ]

const ViewBill = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Payments", icon: <MonetizationOnRoundedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Bill" identifier="bill_num" tabs={tabs} tabContent={tabContent} isProfile={false} url="bills">

    </ViewDetails>
  )
};

export default ViewBill;